{
  "status": {
    "pending": "நிலுவையில்",
    "preliminary": "தொடக்க அறிக்கை",
    "final": "இறுதி அறிக்கை",
    "corrected": "திருத்தம்",
    "amended": "கூடுதல்",
    "addended": "இணைப்புடன்",
    "enteredInError": "உள்ளீட்டுப் பிழை",
    "unknown": "தெரியவில்லை"
  },
  "review": {
    "title": "முடிவுகள் மறுபரிசீலனை",
    "printLabel": "முடிவுகளை அச்சிடுக",
    "summary": {
      "count_one": "{{count}} முடிவு",
      "count_other": "{{count}} முடிவுகள்",
      "criticalUnacknowledged": "{{count}} அபாயகர மதிப்புகள் ஒப்புக்கொள்ளப்படவில்லை"
    },
    "view": {
      "timeline": "காலவரிசை",
      "flowsheet": "ஓட்டத் தாள்"
    },
    "filter": {
      "date": "தேதி",
      "type": "வகை",
      "status": "நிலை",
      "statusAll": "அனைத்தும்"
    },
    "dateRange": {
      "h24": "கடந்த 24 மணி",
      "h48": "கடந்த 48 மணி",
      "d7": "கடந்த 7 நாட்கள்",
      "d30": "கடந்த 30 நாட்கள்",
      "all": "அனைத்தும்"
    },
    "resultType": {
      "all": "அனைத்தும்",
      "lab": "ஆய்வகம்",
      "imaging": "காட்சிப்படுத்தல்",
      "pathology": "நோயியல்",
      "cardiology": "இருதயவியல்",
      "microbiology": "நுண்ணுயிரியல்"
    },
    "criticalOnlyToggle": "அபாயகர மதிப்புகள் மட்டும்",
    "criticalBadge": "அபாயகரம்",
    "actions": {
      "acknowledgeCritical": "அபாயகர மதிப்பை ஒப்புக்கொள்ள",
      "acknowledgeAllCritical": "அனைத்து ஆபத்தான முடிவுகளையும் ஏற்கவும் ({{count}})"
    },
    "detail": {
      "resultNumber": "முடிவு எண்",
      "performingProviderId": "செய்த மருத்துவர் ID",
      "verifiedByProviderId": "சரிபார்த்த மருத்துவர் ID",
      "verifiedAt": "சரிபார்த்த நேரம்",
      "specimenCollected": "மாதிரி சேகரிப்பு நேரம்",
      "clinicalSignificance": "மருத்துவ முக்கியத்துவம்",
      "recommendations": "பரிந்துரைகள்",
      "report": "அறிக்கை",
      "addendum": "இணைப்புரை",
      "criticalAcknowledged": "அபாயகர மதிப்பு ஒப்புக்கொள்ளப்பட்டது",
      "providerHash": "மருத்துவர் #{{id}}",
      "acknowledgedAt": " நேரம் {{when}}",
      "specimenType": "மாதிரி வகை",
      "grossDescription": "வெளிப்புற விவரிப்பு",
      "microscopicDescription": "நுண்ணோக்கி விவரிப்பு",
      "accessionNumber": "அணுகல் எண்",
      "bodyRegion": "உடல் பகுதி",
      "studyInstanceUid": "ஆய்வு நிகழ்வு UID",
      "cardiologyMeasurements": "அளவீடுகள்",
      "heartRate": "HR",
      "prInterval": "PR",
      "qrsDuration": "QRS",
      "qtInterval": "QT",
      "qtcInterval": "QTc",
      "ejectionFraction": "EF"
    },
    "loading": "முடிவுகள் ஏற்றப்படுகின்றன…",
    "loadError": "முடிவுகளை ஏற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "empty": "தேர்ந்தெடுக்கப்பட்ட வடிகட்டிகளுக்கு முடிவுகள் இல்லை.",
    "toast": {
      "acknowledgeSuccess": "அபாயகர முடிவு ஒப்புக்கொள்ளப்பட்டது",
      "acknowledgeError": "முடிவை ஒப்புக்கொள்ள முடியவில்லை"
    },
    "susceptibility": {
      "title": "நுண்ணுயிரிகள் மற்றும் உணர்திறன்",
      "antibiotic": "நுண்ணுயிர்க் கொல்லி",
      "interpretation": "விளக்கம்",
      "mic": "MIC",
      "unnamedOrganism": "பெயரிடப்படாத நுண்ணுயிரி",
      "noPanel": "இந்த நுண்ணுயிரிக்கு உணர்திறன் முடிவுகள் அறிவிக்கப்படவில்லை."
    },
    "components": {
      "value": "மதிப்பு",
      "referenceRange": "குறிப்பு வரம்பு"
    }
  },
  "pending": {
    "title": "நிலுவையில் உள்ள முடிவுகள்",
    "countBadge_one": "நிலுவையில் {{count}}",
    "countBadge_other": "நிலுவையில் {{count}}",
    "autoRefresh": "தானியங்கு புதுப்பிப்பு {{seconds}}வி",
    "updated": "புதுப்பிக்கப்பட்டது {{when}}",
    "searchPlaceholder": "நோயாளி பெயர், MRN அல்லது உத்தரவின் மூலம் தேடவும்…",
    "filtersButton": "வடிகட்டிகள்",
    "fields": {
      "orderType": "உத்தரவு வகை",
      "allTypes": "அனைத்து வகைகள்",
      "priority": "முன்னுரிமை",
      "allPriorities": "அனைத்து முன்னுரிமைகள்",
      "dateFrom": "தொடக்க தேதி",
      "dateTo": "முடிவு தேதி"
    },
    "orderType": {
      "lab": "ஆய்வகம்",
      "imaging": "காட்சிப்படுத்தல்",
      "procedure": "செய்முறை",
      "consultation": "ஆலோசனை",
      "laboratory": "ஆய்வகம்",
      "radiology": "கதிரியக்கவியல்",
      "surgery": "அறுவை சிகிச்சை",
      "therapy": "சிகிச்சை",
      "medication": "மருந்து",
      "admission": "சேர்க்கை"
    },
    "aria": {
      "dateFrom": "நிலுவை முடிவு தொடக்க தேதி",
      "dateTo": "நிலுவை முடிவு முடிவு தேதி"
    },
    "columns": {
      "patient": "நோயாளி",
      "mrn": "MRN",
      "order": "உத்தரவு",
      "type": "வகை",
      "orderedBy": "உத்தரவிட்ட மருத்துவர்",
      "ordered": "உத்தரவு நேரம்",
      "expected": "எதிர்பார்க்கப்படுவது",
      "priority": "முன்னுரிமை"
    },
    "loading": "நிலுவை முடிவுகள் ஏற்றப்படுகின்றன…",
    "loadError": "நிலுவை முடிவுகளை ஏற்ற முடியவில்லை",
    "retry": "மீண்டும் முயல்க",
    "empty": "நிலுவையில் முடிவுகள் இல்லை.",
    "awaitingResult": "முடிவுக்காக காத்திருக்கிறது",
    "specimenReceived": "மாதிரி பெறப்பட்டது",
    "inLab": "ஆய்வகத்தில்",
    "cancelledByLab": "ஆய்வகத்தால் ரத்து செய்யப்பட்டது",
    "overdue": "தாமதம்",
    "expectedBy": "{{date}} முன்பு எதிர்பார்க்கப்படுகிறது"
  },
  "critical": {
    "title": "அபாயகர முடிவுகள்",
    "autoRefresh": "தானியங்கு புதுப்பிப்பு {{seconds}}வி",
    "updated": "புதுப்பிக்கப்பட்டது {{when}}",
    "unacknowledgedHeading_one": "{{count}} அபாயகர மதிப்பு ஒப்புக்கொள்ளப்படவில்லை",
    "unacknowledgedHeading_other": "{{count}} அபாயகர மதிப்புகள் ஒப்புக்கொள்ளப்படவில்லை",
    "escalationBanner": "இம்முடிவுகளை மருத்துவர் உடனடியாக ஒப்புக்கொள்ள வேண்டும்.",
    "acknowledgeWithinMinutes": "{{minutes}} நிமிடத்தில் ஒப்புக்கொள்ள வேண்டும்",
    "routeBackToProvider": "உத்தரவிட்ட மருத்துவரிடம் திருப்பி அனுப்பு",
    "attendingSignoff": "பொறுப்பு மருத்துவர் கையொப்பம் தேவை",
    "searchPlaceholder": "நோயாளி அல்லது சோதனை பெயரால் தேடவும்…",
    "showAcknowledgedToggle": "ஒப்புக்கொள்ளப்பட்டவற்றைக் காட்டு",
    "escalationTime": "T+{{minutes}} நிமி",
    "criticalFallback": "அபாயகரம்",
    "loading": "அபாயகர முடிவுகள் ஏற்றப்படுகின்றன…",
    "loadError": "அபாயகர முடிவுகளை ஏற்ற முடியவில்லை",
    "empty": "ஒப்புதலுக்காக காத்திருக்கும் அபாயகர முடிவுகள் இல்லை.",
    "detailToggleLabel": "முடிவு விவரங்களைக் காட்டு",
    "openFullChart": "முழு மருத்துவப் பதிவைத் திற",
    "columns": {
      "patient": "நோயாளி",
      "mrn": "MRN",
      "test": "சோதனை",
      "value": "மதிப்பு",
      "impression": "கருத்து",
      "resultTime": "முடிவு நேரம்",
      "escalation": "உயர்த்தல்",
      "acknowledged": "ஒப்புக்கொள்ளப்பட்டது",
      "actions": "செயல்கள்"
    },
    "actions": {
      "acknowledge": "ஒப்புக்கொள்"
    },
    "toast": {
      "acknowledgeSuccess": "அபாயகர முடிவு ஒப்புக்கொள்ளப்பட்டது",
      "acknowledgeError": "முடிவை ஒப்புக்கொள்ள முடியவில்லை"
    },
    "refreshFailed": "புதுப்பிக்க முடியவில்லை — {{when}} வரையிலான நெருக்கடி முடிவுகள் காட்டப்படுகின்றன.",
    "incomplete": "{{total}} நெருக்கடி முடிவுகளில் {{shown}} காட்டப்படுகின்றன. இந்தப் பட்டியல் முழுமையற்றது."
  },
  "acknowledged": {
    "pending": "ஒப்புதலுக்காக காத்திருக்கிறது",
    "acknowledged": "ஒப்புக்கொள்ளப்பட்டது",
    "escalated": "உயர் நிலைக்கு அனுப்பப்பட்டது",
    "expired": "ஒப்புதல் கால அவகாசம் முடிந்தது"
  },
  "flowsheet": {
    "analyte": "பகுப்பு உருப்படி",
    "empty": "போக்கு காட்ட ஆய்வக உருப்படிகள் இல்லை",
    "emptyHint": "படிமவியல், நோயியல் மற்றும் நுண்ணுயிரியல் அறிக்கைகள் காலவரிசைக் காட்சியில் உள்ளன.",
    "trend": {
      "toggle": "{{analyte}} போக்கு",
      "referenceRange": "குறிப்பு {{range}}",
      "nonNumericOmitted_one": "{{count}} உரை முடிவு வரையப்படவில்லை",
      "nonNumericOmitted_other": "{{count}} உரை முடிவுகள் வரையப்படவில்லை"
    }
  }
}
